import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import convertToDatetime from "../Utility/ConvertToDateTime";
import {
  SelectPicker,
  Input,
  InputGroup,
  DatePicker,
  Button,
  Dropdown,
} from "rsuite";
import {
  useLazyPopulateSelectAppointmentModalQuery,
  useMakeappointmentMutation,
  useRescheduleAppointmentMutation,
  useLazyGetDoctorsScheduleQuery,
} from "../../State/Api/MakeAppointmentApiSlice";
import { UserOutlined } from "@ant-design/icons";
import SearchIcon from "@rsuite/icons/Search";
import "@schedule-x/theme-default/dist/index.css";
import "rsuite/dist/rsuite.min.css";
import { AutoComplete } from "antd";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { generateValidationSchema } from "../Validations";
import dayjs from "dayjs";
import DocScheduleCalendar from "./DocScheduleCalendar";
import { ToastContainer, toast } from "react-toastify";

function AddAppointmentModal({
  show,
  setShow,
  prefilledDoctorName,
  prefilledDoctorSpecialization,
  rescheduleData,
  setAppointmentToast,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("patientId", location.state);

  const [initialPatientName, setInitialPatientName] = useState("");
  const [isPatientFieldDisabled, setIsPatientFieldDisabled] = useState(false);
  const [initialDoctorName, setInitialDoctorName] = useState("");
  const [isDoctorFieldDisabled, setIsDoctorFieldDisabled] = useState(false);
  const [initialDoctorSpecialization, setInitialDoctorSpecialization] =
    useState("");
  const [isDoctorSpecializationDisabled, setIsDoctorSpecializationDisabled] =
    useState(false);

  const formatAptmntDateForApi = (date) =>
    date ? dayjs(date).format("YYYY-MM-DD") : "";

  useEffect(() => {
    const prefillAll = async () => {
      const prefill = location?.state?.fromRescheduleView;
      if (
        show &&
        prefill?.patientName &&
        prefill?.patientUserUniqueID && // check patient ID exists
        prefill?.doctorSpecialization &&
        prefill?.doctorName &&
        prefill?.doctorID
      ) {
        const {
          patientName,
          patientUserUniqueID, // get patient ID
          doctorSpecialization,
          doctorName,
          doctorID,
        } = prefill;

        // Prefill patient name AND id
        setInitialPatientName(patientName);
        setSearchPatientTerm(patientName);
        formik.setFieldValue("patientName", patientName);
        formik.setFieldValue("userUniqueID", patientUserUniqueID); // set patient ID in Formik
        setIsPatientFieldDisabled(true);

        // Prefill doctor (unchanged)
        await handleDeptChange(doctorSpecialization);

        const doctorResult = await fetchSelectAppointmentModalData({
          searchindex: "Doctor",
          userClinicID: localStorage.getItem("userClinicID"),
          specialization: doctorSpecialization,
          doctorID: 0,
          patient: "",
          weekday: "",
        }).unwrap();

        const matchedDoctor = doctorResult?.doctors?.find(
          (doc) => doc.doctorName === doctorName
        );

        if (matchedDoctor) {
          await handleDeptChange(doctorSpecialization);
          await handleDocChange(matchedDoctor);

          setInitialDoctorName(matchedDoctor.doctorName);
          setInitialDoctorSpecialization(doctorSpecialization);

          formik.setFieldValue("doctorName", matchedDoctor.doctorName);
          formik.setFieldValue("doctorID", matchedDoctor.doctorID); // set doctor ID in Formik too
          formik.setFieldValue("doctorSpecialization", doctorSpecialization);
        }

        window.history.replaceState({}, document.title);
      }
    };

    prefillAll();
  }, [show]);

  useEffect(() => {
    const prefillFollowUp = async () => {
      const prefill = location?.state?.fromFollowUpView;
      if (
        show &&
        prefill?.patientName &&
        prefill?.patientUserUniqueID &&
        prefill?.doctorSpecialization &&
        prefill?.doctorName &&
        prefill?.doctorID
      ) {
        const {
          patientName,
          patientUserUniqueID,
          doctorSpecialization,
          doctorName,
          doctorID,
        } = prefill;

        // 🩵 Prefill patient
        setInitialPatientName(patientName);
        setSearchPatientTerm(patientName);
        formik.setFieldValue("patientName", patientName);
        formik.setFieldValue("userUniqueID", patientUserUniqueID);
        setIsPatientFieldDisabled(true);

        // 🩵 Prefill doctor
        await handleDeptChange(doctorSpecialization);

        const doctorResult = await fetchSelectAppointmentModalData({
          searchindex: "Doctor",
          userClinicID: localStorage.getItem("userClinicID"),
          specialization: doctorSpecialization,
          doctorID: 0,
          patient: "",
          weekday: "",
        }).unwrap();

        const matchedDoctor = doctorResult?.doctors?.find(
          (doc) => doc.doctorName === doctorName
        );

        if (matchedDoctor) {
          await handleDeptChange(doctorSpecialization);
          await handleDocChange(matchedDoctor);

          setInitialDoctorName(matchedDoctor.doctorName);
          setInitialDoctorSpecialization(doctorSpecialization);

          formik.setFieldValue("doctorName", matchedDoctor.doctorName);
          formik.setFieldValue("doctorID", matchedDoctor.doctorID);
          formik.setFieldValue("doctorSpecialization", doctorSpecialization);
        }

        // Optionally mark appointment type as follow-up
        setSelectedReason("Follow-up");
        formik.setFieldValue("appointmentType", "Follow-up");

        window.history.replaceState({}, document.title);
      }
    };

    prefillFollowUp();
  }, [show]);

  // Also add a useEffect to prefill patient name and ID from location state on mount:
  useEffect(() => {
    if (location?.state?.patientName && location?.state?.patientUserUniqueID) {
      const id = location.state.patientUserUniqueID;
      const name = location.state.patientName;
      setInitialPatientName(name);
      setSearchPatientTerm(name);
      formik.setFieldValue("patientName", name);
      formik.setFieldValue("userUniqueID", id);
      setIsPatientFieldDisabled(true);
      window.history.replaceState({}, document.title);
    }
  }, []);

  useEffect(() => {
    if (initialPatientName) {
      setSearchPatientTerm(initialPatientName);
      formik.setFieldValue("patientName", initialPatientName);
    }
  }, [initialPatientName]);
  useEffect(() => {
    if (initialDoctorSpecialization) {
      setSelectedDept(initialDoctorSpecialization);
      formik.setFieldValue("doctorSpecialization", initialDoctorSpecialization);
    }
  }, [initialDoctorSpecialization]);
  useEffect(() => {
    if (initialDoctorName) {
      setSearchTerm(initialDoctorName);
      formik.setFieldValue("doctorName", initialDoctorName);
    }
  }, [initialDoctorName]);

  useEffect(() => {
    if (location?.state?.patientName) {
      setInitialPatientName(location.state.patientName);
      setIsPatientFieldDisabled(true);
      window.history.replaceState({}, document.title);
    }
  }, []);
  useEffect(() => {
    if (show && location?.state?.patientName) {
      setInitialPatientName(location.state.patientName);
      setIsPatientFieldDisabled(true);

      setSearchPatientTerm(location.state.patientName); // apply directly
      formik.setFieldValue("patientName", location.state.patientName);

      // Clean up the navigation state
      window.history.replaceState({}, document.title);
    }
  }, []);

  const fetchDoctorDataAndTimeSlots = async () => {
    if (location?.state?.doctorName && location?.state?.doctorSpecialization) {
      const doctorResult = await fetchSelectAppointmentModalData({
        searchindex: "Doctor",
        userClinicID: localStorage.getItem("userClinicID"),
        specialization: location.state.doctorSpecialization,
        doctorID: 0,
        patient: "",
        weekday: "",
      }).unwrap();

      const matchedDoctor = doctorResult.doctors.find(
        (doc) => doc.doctorName === location.state.doctorName
      );

      if (matchedDoctor) {
        await handleDeptChange(location.state.doctorSpecialization);
        await handleDocChange(matchedDoctor); // 🔥 This triggers time slot fetching

        setInitialDoctorName(matchedDoctor.doctorName);
        setInitialDoctorSpecialization(location.state.doctorSpecialization);

        formik.setFieldValue("doctorName", matchedDoctor.doctorName);
        formik.setFieldValue(
          "doctorSpecialization",
          location.state.doctorSpecialization
        );
      }
    }
  };

  useEffect(() => {
    fetchDoctorDataAndTimeSlots();
  }, []);

  useEffect(() => {
    if (prefilledDoctorName && prefilledDoctorSpecialization) {
      // Prefill only if values exist
      fetchDoctorDataAndTimeSlots();
      setIsDoctorFieldDisabled(true);
      setIsDoctorSpecializationDisabled(true);
    } else {
      // Clear fields if modal opened with no doctor data
      setInitialDoctorName("");
      setInitialDoctorSpecialization("");
      setSearchTerm("");
      setSelectedDept(null);
      setSelectedDoctor(null);
      formik.setFieldValue("doctorName", "");
      formik.setFieldValue("doctorSpecialization", "");
      setIsDoctorFieldDisabled(false);
      setIsDoctorSpecializationDisabled(false);
    }
  }, [prefilledDoctorName, prefilledDoctorSpecialization]);

  const [fetchSelectAppointmentModalData] =
    useLazyPopulateSelectAppointmentModalQuery();

  const [makeappointment] = useMakeappointmentMutation();
  const [rescheduleAppointment] = useRescheduleAppointmentMutation();

  const [selectedDept, setSelectedDept] = useState(null);
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [selectedReason, setSelectedReason] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

  const [searchPatientTerm, setSearchPatientTerm] = useState("");
  const [isPatientFocused, setIsPatientFocused] = useState(false);
  const [aptmntDate, setAptmntDate] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  //Preserve Patient and Doctor IDs
  const [patientId, setPatientId] = useState(null);
  const [docId, setDocId] = useState(null);

  //Populate the Departments dropdown and patients dropdown
  const [departments, setDepartments] = useState([]);
  const [patientsData, setPatientsData] = useState([]);

  const filterPastSlots = (slots, selectedDate) => {
    const now = new Date();
    const selected = new Date(selectedDate);

    // Check if selected date is today
    const isToday = now.toDateString() === selected.toDateString();

    if (!isToday) return slots;

    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    return slots.filter((slotStr) => {
      let slot = slotStr.trim().toUpperCase(); // normalize case
      let match = slot.match(/^(\d{1,2}):(\d{2})(AM|PM)$/);

      if (!match) return false; // skip invalid format

      let [_, h, m, period] = match;
      let hours = parseInt(h, 10);
      let minutes = parseInt(m, 10);

      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;

      const slotMinutes = hours * 60 + minutes;

      return slotMinutes > currentMinutes;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchSelectAppointmentModalData({
          searchindex: "Department",
          userClinicID: localStorage.getItem("userClinicID"),
          specialization: "",
          doctorID: 0,
          patient: "",
          weekday: "",
        }).unwrap();

        const patientsResult = await fetchSelectAppointmentModalData({
          searchindex: "Patient",
          userClinicID: localStorage.getItem("userClinicID"),
          specialization: "",
          doctorID: 0,
          patient: "",
          weekday: "",
        }).unwrap();

        // departments (unchanged)
        const uniqueDepartments = [
          ...new Set(
            result.departments.flatMap((item) =>
              item.department.split(",").map((dep) => dep.trim())
            )
          ),
        ];

        // patients (new structure)
        const uniquePatients = [
          ...new Map(
            patientsResult.patients.map((p) => {
              return [
                p.patientUserUniqueID, // key (ensures uniqueness)
                { id: p.patientUserUniqueID, name: p.patientNames }, // value
              ];
            })
          ).values(),
        ];

        setPatientsData(uniquePatients);
        setDepartments(uniqueDepartments);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const getMissingFields = ({
    selectedDept,
    searchTerm,
    searchPatientTerm,
    aptmntDate,
    selectedVisit,
    selectedReason,
    isRescheduleMode,
    additionalInfo,
  }) => {
    const missing = [];

    if (!selectedDept) missing.push("Department");
    if (!searchTerm) missing.push("Doctor");
    if (!searchPatientTerm) missing.push("Patient");
    if (!aptmntDate) missing.push("Check-in Date");
    if (!selectedVisit) missing.push("Visit Type");
    if (!selectedReason) missing.push("Reason for Visit");
    if (isRescheduleMode && !additionalInfo?.trim()) {
      missing.push("Reason for Rescheduling");
    }

    return missing;
  };

  //handle departments change and set Doctors list
  const [doctors, setDoctors] = useState([]);

  const handleDeptChange = async (eventKey, event) => {
    setSelectedDept(eventKey);
    formik.setFieldValue("department", eventKey);

    // 🔁 Reset Doctor related state
    setSelectedDoctor(null);
    setSearchTerm(""); // Clear doctor input
    formik.setFieldValue("doctorName", "");

    setAptmntDate(null);
    formik.setFieldValue("appointmentDate", "");
    setSelectedTimeSlot(null);
    setTimeSlots([]);

    // ✅ Only clear patient if it's not prefilled
    // if (!isPatientFieldDisabled) {
    //   setSearchPatientTerm("");
    //   formik.setFieldValue("patientName", "");
    // }

    // 🔁 Reset time slots
    setTimeSlots([]);
    setSelectedTimeSlot(null);
    formik.setFieldValue("timeSlot", "");

    // 🔁 Reset Visit Type
    setSelectedVisit(null);
    formik.setFieldValue("visitType", "");

    // 🔁 Reset Appointment Type
    setSelectedReason(null);
    formik.setFieldValue("appointmentType", "");

    try {
      const result = await fetchSelectAppointmentModalData({
        searchindex: "Doctor",
        userClinicID: localStorage.getItem("userClinicID"),
        specialization: eventKey,
        doctorID: 0,
        patient: "",
        weekday: "",
      }).unwrap();

      const uniqueDoctors = [...result.doctors];
      setDoctors(uniqueDoctors);
      setPatientId((prev) => prev); // Preserve patient ID
      setDocId((prev) => prev); // Preserve doctor ID
    } catch (error) {
      console.error("Failed to fetch doctors for department:", error);
      setDoctors([]);
    }
  };

  //handle Doctors chnage and set time slots
  const [timeSlots, setTimeSlots] = useState([]);
  const [timeSlotsLoading, setTimeSlotsLoading] = useState(false);

  const handleDocChange = async (doc) => {
    if (!doc || !doc.doctorID) {
      console.warn("❌ Invalid doctor object:", doc);
      setSelectedDoctor(null);
      setSearchTerm("");
      setTimeSlots([]);
      formik.setFieldValue("doctorName", "");
      formik.setFieldValue("doctorID", "");
      return;
    }

    // 🔁 Reset Appointment Date & Time slot
    setAptmntDate(null);
    formik.setFieldValue("appointmentDate", "");
    setSelectedTimeSlot(null);
    setTimeSlots([]);
    formik.setFieldValue("timeSlot", "");

    // 🔁 Reset Visit Type
    setSelectedVisit(null);
    formik.setFieldValue("visitType", "");

    // 🔁 Reset Appointment Type
    setSelectedReason(null);
    formik.setFieldValue("appointmentType", "");

    // ✅ Set doctor details
    setSelectedDoctor(doc);
    setSearchTerm(doc.doctorName);
    formik.setFieldValue("doctorName", doc.doctorName);
    formik.setFieldValue("doctorID", doc.doctorID); // store ID in formik too

    try {
      setTimeSlotsLoading(true);

      const result = await fetchSelectAppointmentModalData({
        searchindex: "TimeSlot",
        userClinicID: localStorage.getItem("userClinicID"),
        specialization: selectedDept,
        doctorID: doc.doctorID,
        patient: "",
        weekday: "", // you can fill based on appointment date
      }).unwrap();

      setTimeSlots(result.timeSlots || []);
      setPatientId((prev) => prev); // Preserve patient ID
      setDocId(doc.doctorID); // Preserve doctor ID
    } catch (error) {
      console.error("❌ Failed to fetch time slots for doctor:", error);
      setTimeSlots([]);
    } finally {
      setTimeSlotsLoading(false);
    }
  };

  //Get Doctors Schedule
  const [getDocSchedule] = useLazyGetDoctorsScheduleQuery();
  const [docSchedule, setDocSchedule] = useState([]);

  useEffect(() => {
    const fetchSlotsForDate = async () => {
      // If no date, clear everything
      if (!aptmntDate) {
        setTimeSlots([]);
        setSelectedTimeSlot(null);
        return;
      }

      // If doctor not selected, don't fetch
      if (!selectedDoctor?.doctorID) {
        setTimeSlots([]);
        return;
      }

      try {
        setTimeSlotsLoading(true); // start loading
        setTimeSlots([]); // clear old slots

        const weekday = formatAptmntDateForApi(aptmntDate);

        const result = await fetchSelectAppointmentModalData({
          searchindex: "Timeslot",
          userClinicID: localStorage.getItem("userClinicID"),
          specialization: "",
          doctorID: selectedDoctor.doctorID,
          patient: "",
          weekday,
        }).unwrap();

        const schedule = await getDocSchedule({
          doctorID: selectedDoctor.doctorID,
          appointmentDate: dayjs(aptmntDate).format("YYYY-MM-DD"),
        }).unwrap();

        setDocSchedule(
          schedule.map((item, index) => ({
            id: index,
            start: convertToDatetime(
              item.timeSlot,
              dayjs(item.appointmentDate).format("YYYY-MM-DD")
            ).startTime,
            end: convertToDatetime(
              item.timeSlot,
              dayjs(item.appointmentDate).format("YYYY-MM-DD")
            ).endTime,
            title: item.patientName,
          }))
        );

        if (result?.timeslots?.length) {
          const filtered = filterPastSlots(
            result.timeslots.map((slot) => slot.timeslot),
            aptmntDate
          );
          setTimeSlots(filtered);
        } else {
          setTimeSlots([]);
        }
      } catch (err) {
        console.error(err);
        setTimeSlots([]);
      } finally {
        setTimeSlotsLoading(false); // stop loading
      }
    };

    fetchSlotsForDate();
  }, [aptmntDate, selectedDoctor]);

  const isRescheduleMode = Boolean(location.state?.fromRescheduleView);
  const isFollowUpMode = Boolean(location.state?.fromFollowUpView);
  console.log(isRescheduleMode, isFollowUpMode);

  const formFields = ["status"];
  const validationSchema = generateValidationSchema(formFields);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      department: selectedDept
        ? selectedDept
        : isRescheduleMode
        ? rescheduleData?.doctorSpecialization || ""
        : selectedDept || "",
      doctorID: docId
        ? docId
        : isRescheduleMode
        ? rescheduleData?.doctorID || ""
        : docId,
      userUniqueID: isFollowUpMode
        ? location?.state?.fromFollowUpView?.patientUserUniqueID || ""
        : isRescheduleMode
          ? rescheduleData?.patientUserUniqueID || "" : location?.state?.patientUserUniqueID || "" ?  location?.state?.patientUserUniqueID : patientId,
      appointmentDate: aptmntDate ? aptmntDate.toLocaleDateString("en-CA") : "",
      timeSlot: selectedTimeSlot || "",
      appointmentType: selectedReason || "",
      visitType: selectedVisit || "",
      additionalInfo: "",
      status: isRescheduleMode
        ? "Rescheduled"
        : (isFollowUpMode ? "Scheduled" : "Scheduled") || "",
      isActive: true,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      debugger;
      console.log("Formik Values on Submit:", values);
      const missingFields = getMissingFields({
        selectedDept,
        searchTerm,
        searchPatientTerm,
        aptmntDate,
        selectedVisit,
        selectedReason,
        isRescheduleMode,
        additionalInfo: values.additionalInfo,
      });

      if (missingFields.length > 0) {
        missingFields.forEach((field) => toast.error(`Please select ${field}`));
        return;
      }

      try {
        // 🟢 1. Reschedule existing appointment
        if (isRescheduleMode) {
          const payload = {
            appointmentID: rescheduleData?.appointmentID,
            appointmentDate: values.appointmentDate,
            reasonForReschedule: values.additionalInfo,
            doctorID: values.doctorID,
            department: values.department,
            timeSlot: values.timeSlot,
            appointmentType: values.appointmentType,
            visitType: values.visitType,
          };

          const result = await rescheduleAppointment(payload).unwrap();

          if (result?.result_Code === 100) {
            setAppointmentToast("success");
            navigate("/clinic/appointments");
            setShow(false);
          } else if (result?.result_Code === 200) {
            setAppointmentToast("updated");
            navigate("/clinic/appointments");
          } else if (result?.result_Code === 300) {
            setAppointmentToast("exists");
          } else {
            alert(
              "Failed to reschedule appointment: " +
                (result?.result_Message || "")
            );
          }
        }

        // 🟢 2. Create follow-up appointment (uses makeappointment)
        else if (isFollowUpMode) {
          
          const payload = {
            department: values.department,
            doctorID: values.doctorID,
            doctorSpecialization: values.department,
           patientName:
  location?.state?.fromFollowUpView?.patientName ||
  rescheduleData?.patientName ||
  "",
            userUniqueID:
  values.userUniqueID ||
  location?.state?.fromFollowUpView?.patientUserUniqueID ||
  rescheduleData?.patientUserUniqueID ||
  null,
            appointmentDate: values.appointmentDate,
            timeSlot:
              values.appointmentType === "Emergency"
                ? "00:00"
                : values.timeSlot,
            visitType: values.visitType,
            appointmentType: values.appointmentType,
            isActive: values.isActive,
            additionalInfo: values.additionalInfo,
            status: values.status,
            insertedDate: new Date().toISOString().split("T")[0],
          };

          const result = await makeappointment(payload).unwrap();

          console.log("Follow-up appointment result:", result);

          if (result?.result_Code === 100) {
            setAppointmentToast("success");
            formik.resetForm();
            setShow(false);
            navigate("/clinic/appointments");
          } else if (result?.result_Code === 200) {
            setAppointmentToast("updated");
          } else if (result?.result_Code === 300) {
            setAppointmentToast("exists");
          } else {
            alert(
              "Failed to create follow-up appointment: " +
                (result?.result_Message || "")
            );
          }
        }

        // 🟢 3. Normal new appointment creation
        else {
          const payload = {
            userUniqueID: values.userUniqueID,
            doctorID: values.doctorID,
            department: values.department,
            appointmentDate: values.appointmentDate,
            timeSlot:
              values.appointmentType === "Emergency"
                ? "00:00"
                : values.timeSlot,
            appointmentType: values.appointmentType,
            visitType: values.visitType,
            isActive: values.isActive,
            additionalInfo: values.additionalInfo,
            status: values.status,
          };
          console.log("userUniqueID:", values.userUniqueID);

          const result = await makeappointment(payload).unwrap();

          if (result?.result_Code === 100) {
            setAppointmentToast("success");
            formik.resetForm();
            setShow(false);
            navigate("/clinic/appointments");
          } else if (result?.result_Code === 200) {
            setAppointmentToast("updated");
          } else if (result?.result_Code === 300) {
            setAppointmentToast("exists");
          } else {
            alert(
              "Failed to make appointment: " + (result?.result_Message || "")
            );
          }
        }
      } catch (err) {
        setAppointmentToast("error");
        console.error("Appointment API error:", err);
      }
    },
  });

  const Visittype = ["In-Person"];

  const Reasontype = ["General Check-up", "Follow-up", "Emergency"];
  const Status = ["Scheduled", "Cancel", "Resecheduled"];

  useEffect(() => {
    if (rescheduleData?.isFollowUp) {
      formik.setFieldValue("appointmentType", "Follow-up");
      setSelectedReason("Follow-up");
    }
  }, [rescheduleData]);

  const statusColors = {
    Scheduled: "#28a745", // Green
    Cancel: "#dc3545", // Red
    Rescheduled: "#fd7e14", // Orange
  };

  const isCreatingNew =
    !location?.state?.fromDoctorView && !location?.state?.patientName;
  useEffect(() => {
    if (!show && isCreatingNew) {
      formik.resetForm();
      setSelectedDept(null);
      setSelectedDoctor(null);
      setSearchTerm("");
      setSearchPatientTerm("");
      setSelectedVisit(null);
      setSelectedReason(null);
      setTimeSlots([]);
      setSelectedStatus(null);
      setInitialPatientName(""); // ✅
      setIsPatientFieldDisabled(false); // ✅
    }
  }, [show, isCreatingNew]);

  const filteredPatients = patientsData.filter((patient) =>
    patient.name.toLowerCase().includes(searchPatientTerm.toLowerCase())
  );

  const filteredDoctors = doctors.filter((doc) =>
    doc.doctorName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  let stylez = `
  .sx-react-calendar-wrapper{
    width: 100%;
    max-height: 38rem;
  }

  .sx__view-selection{
    display: none;
  }



  .sx__week-grid__date-axis {
    padding-left: 1.5rem;
    display: flex;
}

.sx__week-grid__date
 {
    flex: unset;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: var(--sx-spacing-padding3) 0;
    gap: var(--sx-spacing-padding1);
}

.sx__view-container {        /* hides both scrollbars and scrolling */
  scrollbar-width: none;    /* hides scrollbar in Firefox */
  -ms-overflow-style: none; /* hides scrollbar in IE and Edge */
}

/* hides scrollbar in WebKit browsers like Chrome and Safari */
.sx__view-container::-webkit-scrollbar {
  display: none;
}

.sx__calendar{
  border: unset;
  border-radius: unset;
}

.cust-bg-tint{
  background-color: #8080800d;
}

.styled-label {
  font-size: .8rem;
  font-weight: 600;
  margin-bottom: .2rem;
  color: #6b6b6b;
}

input::placeholder {
  font-weight: 400;
  font-size: .8rem;
  opacity: 0.3;
  color: #adadad;
}

.rs-picker-toggle-placeholder {
  font-weight: 400;
  font-size: .8rem;
  color: #73717161 !important;
}

.rs-picker-popup.rs-picker-popup-date{
  z-Index : 10000;
}

.bdr-styled-container{
  border: 1px solid #8080804a;
  border-radius: 5px;
  min-height: 7rem;
}

.rs-input-group .rs-form-control-wrapper~.rs-input-group-addon, .rs-input-group input.rs-input~.rs-input-group-addon{
  color: #7eb18c;
  background-color: transparent;
}

.rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-indicator .rs-picker-caret-icon, .rs-picker-default .rs-picker-toggle.rs-btn .rs-picker-toggle-indicator .rs-picker-clean{
  color: #7eb18c;
}

.rs-btn-ghost.rs-btn-active, .rs-btn-ghost:active {
  background-color: transparent;
  border-color: #004299;
  border-color: #7eb18c;
  color: #004299;
  color: #7eb18c;
}

.rs-btn-ghost:focus, .rs-btn-ghost:hover {
  background-color: transparent;
  border-color: #7eb18c;
  border-color: #7eb18c;
  -webkit-box-shadow: 0 0 0 1px #0a5dc2;
  -webkit-box-shadow: 0 0 0 1px var(--rs-btn-ghost-hover-border);
  box-shadow: 0 0 0 1px #0a5dc2;
  box-shadow: 0 0 0 1px #7eb18c;
  color: #7eb18c;
  color: #7eb18c;
}

.sx__week-grid__hour-text {
  color: #7eb18c;
}
.sx__week-grid__date--is-today .sx__week-grid__date-number{
  background-color: #7eb18c;
}

.sx__date-picker__day.sx__date-picker__day--today{
  background-color: #7eb18c;
}

.sx__date-picker__month-view-header__month-year:hover{
  color: #7eb18c;
}

.sx__date-picker__day.sx__date-picker__day--selected {
  background-color: #7eb18c6e;
  color: #fffefe;
}

.sx__date-input--active .sx__date-input {
  border-color: #7eb18c;
  outline: 1px solid #7eb18c;
}

.sx__date-input--active .sx__date-input-label{
  color: #7eb18c;
}

.sx__week-grid__date--is-today .sx__week-grid__day-name{
  color: #7eb18c;
}

.sx__is-calendar-small .sx__range-heading{
  color: #7eb18c;
}

.sx__time-grid-event{
  background-color: #d7f3df !important;
  color: #4a6d53 !important;
  border-top: 0px;
  border-inline-end: 0px;
  border-bottom: 0px;
  border-inline-start: 4px solid #4a6d53 !important;
}


.aptmnt-svbtn{
  background-color: transparent;
  border: 1px solid #7eb18c;
  color: #7eb18c;
}

.aptmnt-svbtn:hover{
  background-color: #7eb18c;
    color: white;
    border: 1px solid #7eb18c;
}

.rs-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  width : 100%;
}

.scrollable-dropdown .rs-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.custom-dropdown .rs-btn {
  background-color: #fff;
  border: 1px solid #e6e6eb;
  border-radius: 6px;
  height: 40px;
  font-size: 16px;
  color: #6c757d; /* placeholder-like color */
  padding-left: 12px;
  text-align: left;
  width: 100%;
  box-shadow: none;
}

.custom-dropdown .rs-btn:focus,
.custom-dropdown .rs-btn:active,
.custom-dropdown .rs-btn:hover {
  border-color: #86b7fe;
}

.custom-dropdown .rs-dropdown-toggle-caret {
  margin-left: auto;
}

  `;

  return (
    <>
      <style>{stylez}</style>
      <Modal size="xl" show={show} onHide={() => setShow(false)} centered>
        <Modal.Header
          closeButton
          onHide={() => {
    const fromPath = location?.state?.from;

    if (fromPath) {
      navigate(fromPath); // go back to original route
    } else {
      navigate("/clinic/appointments"); // fallback route
    }
  }}
        >
          <Modal.Title>Appointment Scheduling</Modal.Title>
        </Modal.Header>
        <Modal.Body className="cust-bg-tint">
          <div className="d-flex col-12 align-items-start">
            <form className="d-flex col-6 px-2 align-items-start">
              <div className="d-flex col-12 bg-white flex-wrap py-4 px-4 align-items-start">
                <div className="d-flex col-12">
                  <div className="d-flex flex-column ms-auto col-6 ps-1 pe-3">
                    <label className="styled-label">Department <span className="text-danger">*</span></label>
                    <Dropdown
                      id="inpt-Department"
                      title={selectedDept || "Choose Department"}
                      className="custom-dropdown"
                      onSelect={handleDeptChange}
                      onBlur={formik.handleBlur}
                    >
                      {departments?.map((dept, index) => (
                        <Dropdown.Item key={index} eventKey={dept}>
                          {dept}
                        </Dropdown.Item>
                      ))}
                    </Dropdown>
                  </div>

                  <div
                    className="d-flex flex-column ms-auto col-6"
                    style={{ position: "relative" }}
                  >
                    <label className="styled-label" htmlFor="inpt-Lastname">
                      Doctor Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Search by Doctor name"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)} // ✅ typing updates search
                      onFocus={() => {
                        setIsFocused(true);
                        setPatientId((prev) => prev);
                        setDocId((prev) => prev);
                      }}
                      onBlur={() => {
                        setTimeout(() => setIsFocused(false), 200);
                        setPatientId((prev) => prev);
                        setDocId((prev) => prev);
                      }}
                      style={{
                        padding: "8px",
                        border: "1px solid #e6e6eb",
                        marginBottom: "10px",
                        width: "100%",
                        borderRadius: "5px",
                      }}
                    />

                    {isFocused && (
                      <div
                        style={{
                          position: "absolute",
                          top: "70px",
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          width: "100%",
                          maxHeight: "150px",
                          overflowY: "auto",
                          zIndex: 10,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                      >
                        {filteredDoctors.length > 0 ? (
                          filteredDoctors.map((doc, index) => (
                            <p
                              key={index}
                              style={{
                                margin: "5px 10px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleDocChange(doc);
                                setSearchTerm(doc.doctorName); // show name in input
                                formik.setFieldValue("doctorID", doc.doctorID); // send this in API
                                formik.setFieldValue(
                                  "doctorName",
                                  doc.doctorName
                                ); // optional
                                setIsFocused(false);
                                setPatientId((prev) => prev);
                                setDocId((prev) => doc.doctorID);
                              }}
                            >
                              {doc.doctorName}
                            </p>
                          ))
                        ) : (
                          <p style={{ margin: "5px 10px" }}>No match found</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex col-12 mt-3">
                  <div
                    className="d-flex flex-column ms-auto col-6 pe-3"
                    style={{ position: "relative" }}
                  >
                    <label className="styled-label" htmlFor="patient-name">
                      Patient Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Search by patient name"
                      value={searchPatientTerm}
                      onFocus={() => {
                        setIsPatientFocused(true);
                        setPatientId((prev) => prev);
                        setDocId((prev) => prev);
                      }}
                      onBlur={() => {
                        setTimeout(() => setIsPatientFocused(false), 200);
                        setPatientId((prev) => prev);
                        setDocId((prev) => prev);
                      }}
                      onChange={(e) => {
                        setSearchPatientTerm(e.target.value); // typing updates search
                        setPatientId((prev) => prev);
                        setDocId((prev) => prev);
                      }}
                      readOnly={isPatientFieldDisabled}
                      style={{
                        padding: "8px",
                        border: "1px solid #e6e6eb",
                        marginBottom: "10px",
                        width: "100%",
                        borderRadius: "5px",
                        backgroundColor: isPatientFieldDisabled
                          ? "#f5f5f5"
                          : "#fff",
                      }}
                    />
                    {isPatientFocused && !isPatientFieldDisabled && (
                      <div
                        style={{
                          position: "absolute",
                          top: "70px",
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          width: "95%",
                          maxHeight: "150px",
                          overflowY: "auto",
                          zIndex: 10,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                      >
                        {filteredPatients.length > 0 ? (
                          filteredPatients.map((patient) => (
                            <p
                              key={patient.id}
                              style={{
                                margin: "5px 10px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setSearchPatientTerm(patient.name);
                                formik.setFieldValue(
                                  "patientName",
                                  patient.name
                                );
                                formik.setFieldValue(
                                  "userUniqueID",
                                  patient.id
                                );
                                setIsPatientFocused(false);
                                setPatientId(patient.id);
                                setDocId((prev) => prev);
                              }}
                            >
                              {patient.name}
                            </p>
                          ))
                        ) : (
                          <p style={{ margin: "5px 10px" }}>No match found</p>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="d-flex flex-column ms-auto col-6 ps-1 pe-1">
                    <label className="styled-label">Visit Type <span className="text-danger">*</span></label>
                    <Dropdown
                      id="inpt-Department"
                      title={selectedVisit || "Select"}
                      className="custom-dropdown"
                      onSelect={(value) => {
                        setSelectedVisit(value);
                        formik.setFieldValue("visitType", value);
                        setPatientId((prev) => prev); // Preserve patient ID
                        setDocId((prev) => prev); // Preserve doctor ID
                      }}
                    >
                      {Visittype.map((dept, index) => (
                        <Dropdown.Item
                          key={index}
                          eventKey={dept}
                          disabled={dept === "On-Call"}
                        >
                          {dept}
                        </Dropdown.Item>
                      ))}
                    </Dropdown>
                  </div>
                </div>

                <div className="d-flex col-12 mt-3">
                  <div className="d-flex flex-column ms-auto col-6 ps-1 pe-3">
                    <label className="styled-label">Appointment Type <span className="text-danger">*</span></label>
                    <Dropdown
                      id="inpt-Department"
                      title={selectedReason || "Select"}
                      className="custom-dropdown"
                      onSelect={(value) => {
                        setSelectedReason(value);
                        formik.setFieldValue("appointmentType", value);
                        if (value === "Emergency") {
                          formik.setFieldValue("timeSlot", "00:00");
                          setSelectedTimeSlot("00:00");
                        }
                        setPatientId((prev) => prev); // Preserve patient ID
                        setDocId((prev) => prev); // Preserve doctor ID
                      }}
                    >
                      {Reasontype.map((dept, index) => (
                        <Dropdown.Item
                          disabled={isRescheduleMode && dept === "Emergency"}
                          key={index}
                          eventKey={dept}
                        >
                          {dept}
                        </Dropdown.Item>
                      ))}
                    </Dropdown>
                  </div>
                  <div className="d-flex flex-column ms-auto col-6 ps-1 pe-1">
                    <label className="styled-label" htmlFor="appointmentDate">
                      Date of Appointment <span className="text-danger">*</span>
                    </label>
                    <DatePicker
                      value={aptmntDate}
                      onChange={(date) => {
                        setAptmntDate(date);
                        setSelectedTimeSlot(null);
                        if (!date) {
                          setTimeSlots([]); // clear slots if date removed
                          setPatientId((prev) => prev); // Preserve patient ID
                        }
                        formik.setFieldValue(
                          "appointmentDate",
                          date ? date.toLocaleDateString("en-CA") : null
                        );
                        setPatientId((prev) => prev); // Preserve patient ID
                        setDocId((prev) => prev); // Preserve doctor ID
                      }}
                      format="dd-MMM-yyyy"
                      placeholder="dd-mm-yyyy"
                      oneTap
                      style={{ width: 250 }}
                      disabledDate={(date) =>
                        date.getTime() < new Date().setHours(0, 0, 0, 0)
                      }
                    />
                  </div>
                </div>
                <div className="d-flex col-12 mt-3">
                  <div className="d-flex flex-column me-auto col-12 ps-1">
                    <label className="styled-label" htmlFor="inpt-avl-slot">
                      Time slots
                    </label>
                    <div className="bdr-styled-container w-100">
                      {timeSlotsLoading ? (
                        <p style={{ padding: "10px", color: "#666" }}>
                          Loading time slots...
                        </p>
                      ) : Array.isArray(timeSlots) && timeSlots.length > 0 ? (
                        timeSlots.map((timeSlot, index) => (
                          <Button
                            key={index}
                            onClick={() => {
                              if (
                                formik.values.appointmentType !== "Emergency"
                              ) {
                                setSelectedTimeSlot(timeSlot);
                                formik.setFieldValue("timeSlot", timeSlot);
                                setPatientId((prev) => prev); // Preserve patient ID
                                setDocId((prev) => prev); // Preserve doctor ID
                              }
                            }}
                            className={`m-1 ${
                              selectedTimeSlot === timeSlot
                                ? "rs-btn-active"
                                : ""
                            }`}
                            appearance="ghost"
                            color={
                              selectedTimeSlot === timeSlot
                                ? "green"
                                : undefined
                            }
                            disabled={
                              formik.values.appointmentType === "Emergency" ||
                              timeSlotsLoading
                            }
                          >
                            {timeSlot}
                          </Button>
                        ))
                      ) : (
                        <p style={{ padding: "10px", color: "#999" }}>
                          No available time slots. Please select a different
                          date or doctor.
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="d-flex col-12 mt-3">
                  <div className="d-flex flex-column me-auto col-12 ps-1">
                    <label className="styled-label" htmlFor="additionalInfo">
                      {isRescheduleMode
                        ? "Reason for Rescheduling"
                        : rescheduleData?.isFollowUp
                        ? "Additional Info / Notes" // follow-up
                        : "Additional Info / Notes"}
                    </label>
                    <textarea
                      className="rounded border border-gray-100"
                      id="additionalInfo"
                      name="additionalInfo"
                      rows="3"
                      placeholder="Add any additional info"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.additionalInfo}
                    ></textarea>
                    {formik.touched.additionalInfo &&
                      formik.errors.additionalInfo && (
                        <div
                          style={{ fontSize: "0.8rem", color: "red" }}
                          className="lbl-P9urEIgWf1 mt-1"
                        >
                          {formik.errors.additionalInfo}
                        </div>
                      )}
                  </div>
                </div>

                <div className="col-12 d-flex mt-3">
                  <div className="d-flex flex-column col-6 ps-1 pe-3">
                    <label className="styled-label">Status <span className="text-danger">*</span></label>
                    <Dropdown
                      id="inpt-Department"
                      title={
                        <span
                          style={{
                            color: formik.values.status
                              ? statusColors[formik.values.status]
                              : "#6c757d",
                          }}
                        >
                          {formik.values.status || "Choose Status"}
                        </span>
                      }
                      className="custom-dropdown"
                      onSelect={(value) => {
                        if (value !== "Scheduled") return;
                        if (isRescheduleMode) return; // 🔒 prevent changes
                        formik.setFieldValue("status", value);
                        formik.setFieldValue("cancellationReason", "");

                        if (
                          formik.values.status === "Rescheduled" ||
                          formik.values.status === "Cancel"
                        ) {
                          formik.setFieldValue("additionalInfo", "");
                        }
                      }}
                    >
                      {Status.map((status, index) => (
                        <Dropdown.Item
                          key={index}
                          eventKey={status}
                          disabled={status !== "Scheduled"}
                          style={{
                            color: statusColors[status],
                            fontWeight: 500,
                            pointerEvents: isRescheduleMode ? "none" : "auto", // UI hint
                            opacity: isRescheduleMode ? 0.5 : 1,
                          }}
                        >
                          {status}
                        </Dropdown.Item>
                      ))}
                    </Dropdown>

                    {formik.touched.status && formik.errors.status && (
                      <div
                        style={{ fontSize: "0.8rem", color: "red" }}
                        className="lbl-P9urEIgWf1 mt-1"
                      >
                        {formik.errors.status}
                      </div>
                    )}
                  </div>

                  {/* Show "Reason for Cancellation" if status is Cancel */}
                  {formik.values.status === "Cancel" && (
                    <div className="d-flex flex-column col-6 ps-3 pe-1">
                      <label className="styled-label">
                        Reason for Cancellation
                      </label>
                      <InputGroup>
                        <Input
                          name="cancellationReason"
                          placeholder="Mention the reason"
                          value={formik.values.cancellationReason}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </InputGroup>
                      {formik.touched.cancellationReason &&
                        formik.errors.cancellationReason && (
                          <div
                            style={{ fontSize: "0.8rem", color: "red" }}
                            className="lbl-P9urEIgWf1 mt-1"
                          >
                            {formik.errors.cancellationReason}
                          </div>
                        )}
                    </div>
                  )}
                </div>
              </div>
            </form>
            <div className="d-flex col-6 ps-3 pe-2">
              <DocScheduleCalendar docSchedule={docSchedule} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="aptmnt-svbtn" onClick={formik.handleSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddAppointmentModal;
